import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Modal from '../components/Modal';
import auth from '../utils/auth';
import { BillingInfo, getBillingInfo, isApp, startCardSubscription } from '../utils/billing';

// 페이소프트 → 카드 자동결제 전환 안내 (기존 구독 회원에게 보내는 문자의 링크)
const BillingMigrate = () => {
  const history = useHistory();
  const [billing, setBilling] = useState<BillingInfo | null | undefined>(undefined);

  useEffect(() => {
    getBillingInfo().then(setBilling);
  }, []);

  if (!auth.getToken()) {
    return (
      <Modal
        open={true}
        onClose={() => history.push('/')}
        firstButtonLabel="로그인"
        onClickFirstButton={() => history.push('/auth/login')}
        title="결제 방식 변경 안내"
        content={<>로그인 후 문자의 링크를 다시 눌러주세요.</>}
      />
    );
  }

  if (billing === undefined) {
    return <Modal open={true} onClose={() => {}} title="결제 방식 변경 안내" content={<>잠시만 기다려주세요...</>} />;
  }

  // 앱(웹뷰)에서는 결제 화면을 보여주지 않는다 (스토어 결제 정책)
  if (isApp() || !billing || !billing.enabled || !billing.migration) {
    return (
      <Modal
        open={true}
        onClose={() => history.push('/')}
        firstButtonLabel="확인"
        onClickFirstButton={() => history.push('/')}
        title="결제 방식 변경 안내"
        content={
          billing && billing.subscription && billing.subscription.status === 'active'
            ? <>이미 카드 자동결제로 변경되었습니다.</>
            : <>결제 방식 변경 대상이 아닙니다.</>
        }
      />
    );
  }

  return (
    <Modal
      open={true}
      onClose={() => history.push('/')}
      firstButtonLabel="카드 등록"
      onClickFirstButton={() => startCardSubscription(billing)}
      secondButtonLabel="나중에"
      onClickSecondButton={() => history.push('/')}
      title="결제 방식 변경 안내"
      content={
        <>
          코드스코어 구독 결제가 카드 자동결제로 바뀝니다. <br />
          카드를 등록하시면 {billing.first_charge_at}부터 매월 {billing.amount.toLocaleString()}원이 결제되며, 그 전에는 결제되지 않습니다.
        </>
      }
    />
  );
};

export default BillingMigrate;
